<template>
  <div id="totalBox">
    <div class="partnerBox">
      <img src="../../assets/home/partnerIcon.png" class="partnerIcon" alt="" />
      <p class="partnerTitle">成功项目</p>
      <p class="partnerTip">立足实际，根据行业属性适配，满足不同的业态</p>
      <div class="partnerList">
        <div class="partnerLogoBox">
          <img src="../../assets/home/xh.png" style="width: 250px;height: 60px;"/>
        </div>
        <div class="partnerLogoBox">
          <img src="../../assets/home/dh.png" style="width: 215px;height: 110px;"/>
        </div>
        <div class="partnerLogoBox">
          <img src="../../assets/home/sx.png" style="width: 239px;height: 93px;"/>
        </div>
        <div class="partnerLogoBox">
          <img src="../../assets/home/tagz.png" style="width: 142px;"/>
        </div>
      </div>
      <div class="partnerList">
        <div class="partnerLogoBox">
          <img src="../../assets/home/rj.png" style="width: 172px;height: 137px;"/>
        </div>
        <div class="partnerLogoBox">
          <img src="../../assets/home/dz.png" style="width: 121px;height: 118px;"/>
        </div>
        <div class="partnerLogoBox">
          <img src="../../assets/home/wym.png" style="width: 273px;height: 48px;"/>
        </div>
        <div class="partnerLogoBox">
          <div class="callUsBox">
            <div class="callUsPhone">致电我们了解更多</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Partner',
  data: function () {
    return {
      msg: '1'
    }
  }
}
</script>

<style scoped>
#totalBox{
  width: 100%;
  height: 600px;
  background-color:rgba(35, 33, 33, 1);
}
.partnerBox{
  width: 1200px;
  height: 600px;
  margin: 0 auto;
  position: relative;
  padding-top: 50px;
}
.partnerIcon{
  width:706px;
  height:268px;
  position: absolute;
  bottom: 62px;
  right: 0;
}
.partnerTitle{
  font-size:40px;
  font-weight:bold;
  color:rgba(255, 255, 255, 1);
  padding-left: 93px;
  text-align: left;
}
.partnerTip{
  padding-left: 93px;
  text-align: left;
  font-size:20px;
  font-weight:400;
  color:rgba(255, 255, 255, 1);
  margin-top: 22px;
}
.partnerList{
  display: flex;
  flex-wrap:wrap;
  align-items: center;
  justify-content: space-around;
}
.partnerList:first-of-type{
  margin-top: 60px;
}
.partnerList:last-of-type{
  margin-top: 37px;
}
.partnerLogoBox{
  width: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.callUsBox{
  width:200px;
  height: 60px;
  background-color:rgba(255,255,255,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}
.callUsPhone{
  width: 190px;
  height: 50px;
  border:2px solid rgba(35,33,33,0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size:20px;
  font-family:Microsoft YaHei;
  font-weight:bold;
  color:rgba(35,33,33,0.6);
}
</style>



// WEBPACK FOOTER //
// src/components/home/partner.vue